import { Bounce, toast } from "react-toastify";
import { ModeState } from "services/redux/site";

export type ToasterType = "error" | "success" | "info" | "warning";

const customToaster = (type: ToasterType, text: string, mode: ModeState) => {
    // const mode = useSelector((state: RootState) => state.site.mode);
    if (type == "error") {
        toast.error(text, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: mode == "light" ? "light" : "dark",
            transition: Bounce
        });
        return;
    }
    if (type == "success") {
        toast.success(text, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: mode == "light" ? "light" : "dark",
            transition: Bounce
        });
        return;
    }
    if (type == "info") {
        toast.info(text, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: mode == "light" ? "light" : "dark",
            transition: Bounce
        });
        return;
    }
    if (type == "warning") {
        toast.warning(text, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: mode == "light" ? "light" : "dark",
            transition: Bounce
        });
        return;
    }
};

export default customToaster;
